import * as tslib_1 from "tslib";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PlatformCommunicatorAuthService } from './platform-communicator.auth.service';
import { ParametersService } from '../../parameters/parameters.service';
import { AbreCuentasService } from '../../abre-cuentas/abre-cuentas.service';
import { ChannelCommunicatorService } from '../channel-communicator/channel-communicator.service';
import { PlatformEndpointService } from '../endpoint/endpoint.service';
import { RequestHeaderSettings } from './request.header.settings';
import { LogDeviceModel } from 'src/app/shared/models/log-device.model';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./platform-communicator.auth.service";
import * as i3 from "../../parameters/parameters.service";
import * as i4 from "../../abre-cuentas/abre-cuentas.service";
import * as i5 from "../endpoint/endpoint.service";
import * as i6 from "../channel-communicator/channel-communicator.service";
var PlataformCommunicatorBitacaraService = /** @class */ (function () {
    function PlataformCommunicatorBitacaraService(_http, authService, parametersService, abreCuentasService, endpointService, channelCommunicatorService) {
        this._http = _http;
        this.authService = authService;
        this.parametersService = parametersService;
        this.abreCuentasService = abreCuentasService;
        this.endpointService = endpointService;
        this.channelCommunicatorService = channelCommunicatorService;
        this.parametrizedHeaders = undefined;
    }
    PlataformCommunicatorBitacaraService.prototype.saveDataInBitacora = function (error) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var eventName, devicePrint, headers, options_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (error.status == 404 && error.url != this.endpointService.URLS.TERMS_CONDITIONS) {
                    eventName = "ups_error_" + error.status + "_" + error.url;
                    devicePrint = new LogDeviceModel();
                    devicePrint.device = this.abreCuentasService.getDeviceInfo();
                    devicePrint.device.event_name = eventName;
                    devicePrint.terms_type = eventName;
                    headers = new HttpHeaders({
                        'token-client-id': '39540626_1',
                        'session_id': this.authService.getSessionId(),
                    });
                    options_1 = {
                        url: this.endpointService.URLS.TERMS_CONDITIONS,
                        method: 'post',
                        body: devicePrint,
                        headers: headers,
                    };
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            _this.request(options_1)
                                .then(function (response) { return resolve(response.body); })
                                .catch(function (err) { return reject(err); });
                        })];
                }
                return [2 /*return*/];
            });
        });
    };
    PlataformCommunicatorBitacaraService.prototype.processHeaders = function (additionalHeaders, url, isPpid, appendSession) {
        var e_1, _a;
        var _this = this;
        var token = this.authService.getSSOInformation().accessToken;
        var sessionId = this.authService.getSessionId();
        var headers = RequestHeaderSettings.getHeaders(token, isPpid);
        headers = headers.append('use_cripto', 'false');
        if (url !== this.endpointService.URLS.API_GATEWAY_SSO) {
            headers = headers.append('transaction_id', this.abreCuentasService.getTransactionId());
            headers = headers.append('channel-id', this.channelCommunicatorService.getChannelId().toString());
        }
        if (token && this.abreCuentasService.parametrizedHeaders !== undefined) {
            var keys = this.abreCuentasService.parametrizedHeaders.keys();
            headers = headers.append('operation_target', this.abreCuentasService.parametrizedHeaders.get('operation_target'));
            keys.map(function (chKey) {
                // tslint:disable-next-line: early-exit
                if (chKey === _this.channelCommunicatorService.getChannelId() && _this.abreCuentasService.parametrizedHeaders !== undefined) {
                    var chHead = _this.abreCuentasService.parametrizedHeaders.get(chKey);
                    for (var key in chHead) {
                        if (Object.prototype.hasOwnProperty.call(chHead, key)) {
                            headers = headers.append(key, chHead[key]);
                        }
                    }
                }
            });
        }
        if (sessionId && appendSession) {
            headers = headers.append('session_id', sessionId);
        }
        if (additionalHeaders !== undefined) {
            var requestHeaders = additionalHeaders;
            var keys = headers.keys();
            try {
                for (var keys_1 = tslib_1.__values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
                    var key = keys_1_1.value;
                    if (requestHeaders.get(key) === null) {
                        requestHeaders = requestHeaders.append(key, headers.get(key));
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            headers = requestHeaders;
        }
        return headers;
    };
    PlataformCommunicatorBitacaraService.prototype.getURLRequest = function (url, method) {
        var backendURLMocked = this.parametersService.getParameter('url_mock_backend');
        if (backendURLMocked) {
            return this.communicatorInterceptor.getBackEndURLMocked(backendURLMocked, url, method);
        }
        return url;
    };
    PlataformCommunicatorBitacaraService.prototype.request = function (options, isPpid, appendSession) {
        if (isPpid === void 0) { isPpid = false; }
        if (appendSession === void 0) { appendSession = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var headers;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                headers = this.processHeaders(options.headers, options.url, isPpid, appendSession);
                options.headers = headers;
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var url = _this.getURLRequest(options.url, options.method);
                        var fucntionParameters;
                        if (url !== options.url) {
                            options.method = 'get';
                        }
                        if (options.method !== 'get' && options.method !== 'delete') {
                            fucntionParameters = [
                                options.url,
                                options.body,
                                { headers: headers, params: options.params, observe: 'response' },
                            ];
                        }
                        else {
                            fucntionParameters = [
                                url,
                                { headers: headers, params: options.params, observe: 'response' },
                            ];
                        }
                        _this._http[options.method].apply(_this._http, fucntionParameters).toPromise().then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            return tslib_1.__generator(this, function (_a) {
                                if (response.status === 200) {
                                    resolve(response);
                                    return [2 /*return*/];
                                }
                                return [2 /*return*/];
                            });
                        }); }, function (error) {
                            reject(error);
                            return;
                        }).catch(function (error) {
                            reject(error);
                            return;
                        });
                    })];
            });
        });
    };
    PlataformCommunicatorBitacaraService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PlataformCommunicatorBitacaraService_Factory() { return new PlataformCommunicatorBitacaraService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.PlatformCommunicatorAuthService), i0.ɵɵinject(i3.ParametersService), i0.ɵɵinject(i4.AbreCuentasService), i0.ɵɵinject(i5.PlatformEndpointService), i0.ɵɵinject(i6.ChannelCommunicatorService)); }, token: PlataformCommunicatorBitacaraService, providedIn: "root" });
    return PlataformCommunicatorBitacaraService;
}());
export { PlataformCommunicatorBitacaraService };
